import { useRouteLoaderData } from '@remix-run/react';

export const useRouteLoaderDataSafe = <T,>(routeId: string) => {
  const data = useRouteLoaderData<T>(routeId);

  return data || ({} as typeof data);
};
